import React from "react"

import {FieldGraphTickLabelViewProps} from "../../../render/graph-tick-label"
import Field_GraphTickLabelView from "../../../proto/render/graph-tick-label"
import FieldRAG_Icon from "../components/rag-icon"

const LABEL_SHOW_THRESHOLD = 100

const debug = false
// const debug = "FieldRAG_GraphTickLabelView"

export default function FieldRAG_GraphTickLabelView(props: FieldGraphTickLabelViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)
    const option = props.field._getOption(value)

    debug && console.log(debug, 'render', option, props)

    let showLabel = props.params.availableWidth > LABEL_SHOW_THRESHOLD

    const iconClasses = Classes('flex-row-center-center flex-no-shrink', {
        'm-r-5': showLabel
    })

    return (
        <Field_GraphTickLabelView {...props} hintName={option.label}>
            <FieldRAG_Icon className={iconClasses} option={option} />
            {showLabel && <div className="ui5-txt-default-small txt-truncate">{props.field.groupLabel(value)}</div>}
        </Field_GraphTickLabelView>
    )
}